import React from "react";

const FaithGatheringIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.058 2.0798C11.9178 2.0198 11.7658 1.9926 11.6135 2.0003C11.4613 2.008 11.3128 2.0505 11.1794 2.1244C11.0461 2.1983 10.9314 2.3017 10.8441 2.4268C10.7569 2.5518 10.6994 2.6952 10.676 2.8458C10.6494 3.0741 10.5759 3.2944 10.46 3.4928C10.36 3.6578 10.21 3.8268 9.946 4.0728C9.426 4.5548 9.109 5.1318 9.024 5.7538C8.9499 6.3263 9.0643 6.9073 9.35 7.4088C9.842 8.2958 10.84 8.9998 11.903 8.9998C13.285 8.9998 15 8.0338 15 6.1938C15 5.2508 14.578 4.3648 14.054 3.6818C13.526 2.9948 12.811 2.4028 12.058 2.0808M11.306 5.5398C11.616 5.2528 11.918 4.9398 12.159 4.5498C12.267 4.6578 12.371 4.7748 12.468 4.9008C12.825 5.3668 13 5.8338 13 6.1948C13 6.3918 12.914 6.5708 12.72 6.7268C12.4853 6.9057 12.1981 7.002 11.903 7.0008C11.688 7.0008 11.3 6.8028 11.098 6.4388C11.0231 6.316 10.9905 6.172 11.005 6.0288C11.019 5.9208 11.078 5.7518 11.306 5.5398ZM9 9.9998C8.46957 9.9998 7.96086 10.2105 7.58579 10.5856C7.21071 10.9607 7 11.4694 7 11.9998V19.9998C7 20.5303 7.21071 21.039 7.58579 21.414C7.96086 21.7891 8.46957 21.9998 9 21.9998H15C15.5304 21.9998 16.0391 21.7891 16.4142 21.414C16.7893 21.039 17 20.5303 17 19.9998V11.9998C17 11.4694 16.7893 10.9607 16.4142 10.5856C16.0391 10.2105 15.5304 9.9998 15 9.9998H9ZM9 11.9998H15V19.9998H9V11.9998Z"
      fill="currentColor"
    />
  </svg>
);

export default FaithGatheringIcon;
